import React from 'react';
import { IGenerateIconProps } from '../Types/BulkPricingTypes';

export const FieldIcon = (props: IGenerateIconProps) => {
  const { column, hiddenFor } = props;

  return (
    <>
      { hiddenFor.some((term: string) => column.name === term) ?  
        null : 
        column.term?.includes('market') ? 
        <i className="icon-circle isComposite table-header-icon"/> : 
        <i className="icon-circle table-header-icon"/>} 
    </>
  )
}